import {
  breakpointSizes,
  getBreakpointDown,
  getBreakpointUp,
  styleConstants,
} from '@paywithextend/components'
import React from 'react'
import { css } from 'styled-components'

interface BoxAndLinksProps {
  className?: string
  links?: React.ReactElement[]
}

const BoxAndLinks: React.FC<React.PropsWithChildren<BoxAndLinksProps>> = (
  props,
): React.ReactElement => {
  return (
    <div
      className={props.className}
      css={css`
        display: flex;
        flex-direction: column;
      `}
    >
      {props.links && (
        <div
          css={css`
            display: flex;
            justify-content: flex-end;
            margin-bottom: ${styleConstants.heights.majorInternalGutter};
            margin-right: 40px;

            ${getBreakpointDown(breakpointSizes.XSM)(css`
              flex-direction: column;
              align-items: flex-end;
            `)}
          `}
        >
          {props.links?.map((item, i) => (
            <div
              key={i}
              css={css`
                display: flex;
                align-items: center;

                ${getBreakpointUp(breakpointSizes.SM)(css`
                  &:nth-child(n + 2) {
                    margin-left: 32px;
                  }
                `)}
              `}
            >
              {item}
            </div>
          ))}
        </div>
      )}
      {props.children}
    </div>
  )
}

export default BoxAndLinks
